export const TestHooks = {
	UpdateButton: 'update-button',
	DisplayNameSpan: 'display-name-span',
} as const;
